export const locale = {
    lang: 'es',
    data: {
        INVENTARIO: {
            EDIT: {
                TITLE: 'MODIFICAR INVENTARIO'
            }
        }
    }
};
